var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablerIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-send",
    clipPath: "url(#clip0_228_729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.2815 19.4119L34.191 20.1036M16.2815 19.4119L13.1021 27.8496C13.0555 27.9616 13.042 28.0847 13.0633 28.2041C13.0846 28.3236 13.1397 28.4344 13.2221 28.5235C13.3045 28.6125 13.4108 28.676 13.5282 28.7065C13.6457 28.7369 13.7694 28.733 13.8847 28.6951L34.191 20.1036M16.2815 19.4119L13.7623 10.7541C13.7245 10.6388 13.7205 10.5151 13.751 10.3976C13.7814 10.2801 13.8449 10.1739 13.934 10.0915C14.023 10.009 14.1338 9.95392 14.2533 9.93264C14.3728 9.91137 14.4958 9.92484 14.6078 9.97145L34.191 20.1036",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_228_729"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6511,
    height: 27.6511,
    fill: "white",
    transform: "translate(20.292) rotate(47.2117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerIconSend);
export default __webpack_public_path__ + "static/media/tabler-icon-send.3b09fd91a87df62cbba1bc9d44fe6761.svg";
export { ForwardRef as ReactComponent };